var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("予測降雨透明度")]),_c('v-slider',{attrs:{"hide-details":"","step":0.01,"max":1,"min":0},model:{value:(_vm.opacity),callback:function ($$v) {_vm.opacity=$$v},expression:"opacity"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }